import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as Bowser from "bowser";
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class NoMobileGuard  {
  constructor(
    private toastrService: ToastrService,
    private translate: TranslateService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const browser = Bowser.getParser(window.navigator.userAgent);

    const platform = browser.getPlatform();

    if (platform.type === 'mobile') {      
      this.toastrService.error(
        this.translate.instant('guards.notSupportedDevice.message'),
        this.translate.instant('guards.notSupportedDevice.title'),
        {
          closeButton: true,
          timeOut: 8000,
          onActivateTick: true,
          positionClass: 'toast-center-center',
        },
      );
      return false;
    }
    return true;
  }
}
